import { Button, Typography } from 'antd';
import React from 'react';
import styled from 'styled-components';
import { useTranslation } from '../../../../../../../../i18n/useTranslation';
import { GetDatasetQuery } from '../../../../../../../../graphql/dataset.generated';
import { InfoItem } from '../../../../../components/styled/InfoItem';
import { ANTD_GRAY } from '../../../../../constants';
import { useBaseEntity, useRouteToTab } from '../../../../../EntityContext';
import { SidebarHeader } from '../../SidebarHeader';

const HeaderInfoBody = styled(Typography.Text)`
    font-size: 16px;
    color: ${ANTD_GRAY[9]};
`;

const StatsButton = styled(Button)`
    // margin-top: -4px;
`;

const InfoRow = styled.div`
    // padding-top: 12px;
    // padding-bottom: 12px;
`;

const INFO_ITEM_WIDTH_PX = '150px';

export const SidebarViewDefinitionSection = () => {
    const baseEntity = useBaseEntity<GetDatasetQuery>();

    const materialized = baseEntity?.dataset?.viewProperties?.materialized;
    const language = baseEntity?.dataset?.viewProperties?.language || 'UNKNOWN';

    const routeToTab = useRouteToTab();
    const { t } = useTranslation();

    return (
        <div className="pa-4">
            <SidebarHeader
                title={t('View Definition')}
                actions={
                    <StatsButton onClick={() => routeToTab({ tabName: t('View Definition') })} type="link">
                        {t('View Definition')} &gt;
                    </StatsButton>
                }
            />
            <InfoRow className="f-info-cards">
                <InfoItem title={t('Materialized')} width={INFO_ITEM_WIDTH_PX}>
                    <HeaderInfoBody>{materialized ? t('True') : t('False')}</HeaderInfoBody>
                </InfoItem>
                <InfoItem title={t('Language')} width={INFO_ITEM_WIDTH_PX}>
                    <HeaderInfoBody>{language.toUpperCase()}</HeaderInfoBody>
                </InfoItem>
            </InfoRow>
        </div>
    );
};
